import { render } from "./page5.vue?vue&type=template&id=9aba3118&scoped=true"
import script from "./page5.vue?vue&type=script&lang=js"
export * from "./page5.vue?vue&type=script&lang=js"

import "./page5.vue?vue&type=style&index=0&id=9aba3118&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aba3118"]])

export default __exports__